import { Observable } from "rxjs"
import RandomSelectionRow from "./RandomsModel/RandomSelectionRow"
import { ObservableFromFetch } from "../ObservableFromFetch"
import { AccountTypeID } from "../../config/Constants"

export default function RandomSelectionListGetObservable(poolId: number, poolSelectionId: number, accountID: number): Observable<RandomSelectionRow[]> {
  const params: string = JSON.stringify({
    Extra: "false",
    PageSize: 25,
    PoolID: poolId,
    AccountID: accountID,
    PoolMembersID: [],
    PoolSelectionID: poolSelectionId,
    ProfileAccountTypeID: AccountTypeID
  })

  return ObservableFromFetch<RandomSelectionRow[]>("RandomTest/GetRandomSelectionList", params)
}
